import Lottie from 'lottie-react'
import geofenceAnimation from '../../assets/animations/Geofence.json'

interface GeofenceIconProps {
  size?: number
  className?: string
}

const GeofenceIcon = ({ size = 24, className = '' }: GeofenceIconProps) => {
  return (
    <div style={{ width: size, height: size, aspectRatio: '1 / 1', contain: 'layout' }} className={className}>
      <Lottie
        animationData={geofenceAnimation}
        loop={true}
        autoplay={true}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  )
}

export default GeofenceIcon